import React from 'react';
import { Modal,ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
//import { FormMicTypeSample } from './FormMicTypeSample';
//import { DeleteMicTypeSample } from './DeleteMicTypeSample';
import { FormMicCatalogs } from './FormMicCatalogs';
import { DeleteMicCatalogs } from './DeleteMicCatalogs';
import { Dialog } from 'primereact/dialog';

export const ModalMicCatalogs = (props) => {
    const{
        modal, tittle, toggle, method,
        name,description,estatus,
        handleInputChange, loading,closeDialog,
        saveCreate,saveUpdateMic,saveDeleteMic
    }=props;

    return (
        <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                ?<FormMicCatalogs
                    button = {ModalButtonSave}
                    {...{closeDialog, loading, handleInputChange, name,description,estatus, methodAction: saveCreate}}
                />
                :
                (method === "update")
                ?
                <FormMicCatalogs
                    button={ModalButtonUpdate}
                    {...{ closeDialog, loading, handleInputChange, methodAction: saveUpdateMic, name,description,estatus }}
                />
                :
                null
            }
        </Dialog>
    )
}